var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import * as s from './LineItems.scss';
import { Text } from 'wix-style-react';
import { currencyFormat } from '../../../core';
import { translate } from 'react-i18next';
var LineItems = function (_a) {
    var t = _a.t, lineItems = _a.lineItems, locale = _a.locale, currencyCode = _a.currencyCode;
    var currency = currencyFormat({ locale: locale, currency: currencyCode });
    var customHeader = s.customizeHeader;
    var customCell = s.customizeCell;
    var customizePriceTitle = s.customizePriceTitle;
    var customQuantityTitle = s.customizeQuantityTitle;
    var customTotalTitle = s.customizeTotalTitle;
    var customPriceCell = s.customizePriceCell;
    var HeaderLine = function (_a) {
        var children = _a.children, props = __rest(_a, ["children"]);
        return (React.createElement(Text, __assign({ size: "small", weight: 'bold', secondary: true }, props), children));
    };
    return (React.createElement("table", { className: s.table },
        React.createElement("thead", { className: s.head },
            React.createElement("tr", null,
                React.createElement("th", { className: s.header + " " + customHeader },
                    React.createElement(HeaderLine, { dataHook: "product-title" }, t('invoice-view:price-quote.view.line-items.product'))),
                React.createElement("th", { className: s.header + " " + customHeader + " " + customizePriceTitle },
                    React.createElement(HeaderLine, { dataHook: "price-title" }, t('invoice-view:price-quote.view.line-items.price'))),
                React.createElement("th", { className: s.header + " " + customHeader + " " + customQuantityTitle },
                    React.createElement(HeaderLine, { dataHook: "quantity-title" }, t('invoice-view:price-quote.view.line-items.quantity'))),
                React.createElement("th", { className: s.header + " " + customHeader + " " + s.pullRight + " " + customTotalTitle },
                    React.createElement(HeaderLine, { dataHook: "total-title" }, t('invoice-view:price-quote.view.line-items.total'))))),
        React.createElement("tbody", null, lineItems.map(function (_a, index) {
            var name = _a.name, description = _a.description, price = _a.price, quantity = _a.quantity, total = _a.total;
            return [
                React.createElement("tr", { key: index },
                    React.createElement("td", { className: s.cell + " " + customCell },
                        React.createElement("div", { className: s.productName },
                            React.createElement(Text, { dataHook: "name-" + index, size: "small", weight: "normal" }, name)),
                        React.createElement("div", { className: s.description },
                            React.createElement("span", { className: s.spanForThaiPdf, "data-hook": "description-" + index }, description))),
                    React.createElement("td", { className: s.cell + " " + customCell + " " + customPriceCell },
                        React.createElement(Text, { dataHook: "price-" + index, size: "small", weight: "normal" }, currency(price))),
                    React.createElement("td", { className: s.cell + " " + customCell },
                        React.createElement(Text, { dataHook: "quantity-" + index, size: "small", weight: "normal" }, quantity)),
                    React.createElement("td", { className: s.cell + " " + customCell + " " + s.pullRight },
                        React.createElement(Text, { dataHook: "total-" + index, size: "small", weight: "normal" }, currency(total)))),
                React.createElement("tr", { className: s.descriptionRow, key: index + "A" },
                    React.createElement("td", { colSpan: 4 },
                        React.createElement("div", { className: s.descriptionCells },
                            React.createElement(Text, { dataHook: "description-row-" + index, secondary: true, light: true, size: "small" }, description)))),
                React.createElement("tr", { key: index + "B" },
                    React.createElement("td", { colSpan: 4 },
                        React.createElement("hr", { className: s.divider }))),
            ];
        }))));
};
export default translate()(LineItems);
//# sourceMappingURL=LineItems.js.map